export default __webpack_public_path__ + "static/media/Audio.8efd4e0e.webp";